import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "ticket" }
const _hoisted_2 = { class: "ticket__title" }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "icon" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["href"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 4,
  class: "--align-center"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "icon" }, "link", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("tr", _hoisted_1, [
    _createElementVNode("td", {
      class: "ticket__order --align-right --number",
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showOrderPopup && _ctx.showOrderPopup(...args)), ["stop"]))
    }, _toDisplayString(_ctx.index), 1),
    _createElementVNode("td", _hoisted_2, [
      _createElementVNode("a", {
        href: _ctx.link,
        target: "_blank",
        class: _normalizeClass(_ctx.visited.includes(_ctx.ticketObject.internal_id) ? '--visited' : false),
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addToVisited && _ctx.addToVisited(...args))),
        onMouseup: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addToVisited && _ctx.addToVisited(...args)), ["middle"]))
      }, [
        (_ctx.provider === 'all')
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.logoSource,
              alt: ""
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(_ctx.ticketObject.title) + " (#" + _toDisplayString(_ctx.iid) + ") ", 1),
        _withDirectives(_createElementVNode("span", _hoisted_5, "task_alt", 512), [
          [_vShow, _ctx.recentlyVisited.includes(_ctx.ticketObject.internal_id)]
        ])
      ], 42, _hoisted_3)
    ]),
    (_ctx.provider !== 'zammad')
      ? (_openBlock(), _createElementBlock("td", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.labels, (label) => {
            return (_openBlock(), _createElementBlock("span", {
              class: _normalizeClass(['label', '--' + _ctx.labelClass(label)]),
              onClick: _withModifiers(($event: any) => (_ctx.setLabelFilter(label)), ["stop"])
            }, _toDisplayString(label), 11, _hoisted_7))
          }), 256))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("td", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assignees, (assignee) => {
        return (_openBlock(), _createElementBlock("span", {
          class: "assignee",
          onClick: _withModifiers(($event: any) => (_ctx.setAssigneeFilter(assignee.name)), ["stop"])
        }, _toDisplayString(assignee.name), 9, _hoisted_8))
      }), 256))
    ]),
    (_ctx.provider !== 'zammad' && _ctx.view !== 'billing')
      ? (_openBlock(), _createElementBlock("td", {
          key: 1,
          class: _normalizeClass(['--align-right --number', {'--empty': !_ctx.timeStats.human_time_estimate}])
        }, _toDisplayString(_ctx.timeStats.human_time_estimate || 0), 3))
      : _createCommentVNode("", true),
    (_ctx.provider !== 'zammad' && _ctx.view !== 'billing')
      ? (_openBlock(), _createElementBlock("td", {
          key: 2,
          class: _normalizeClass(['--align-right --number', {'--empty': !_ctx.timeStats.human_total_time_spent}])
        }, _toDisplayString(_ctx.timeStats.human_total_time_spent || 0), 3))
      : _createCommentVNode("", true),
    (_ctx.provider !== 'zammad')
      ? (_openBlock(), _createElementBlock("td", {
          key: 3,
          class: _normalizeClass([{'--empty': !_ctx.milestoneObject}])
        }, [
          (_ctx.milestoneObject)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: _ctx.milestoneLink,
                target: "_blank"
              }, _toDisplayString(_ctx.milestoneObject.title), 9, _hoisted_9))
            : _createCommentVNode("", true),
          (!_ctx.milestoneObject)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, "None"))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.provider === 'zammad')
      ? (_openBlock(), _createElementBlock("td", _hoisted_11, [
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showPopup && _ctx.showPopup(...args)), ["stop"])),
            class: "button --small --outline"
          }, [
            _createTextVNode(" Gitlab "),
            _hoisted_12
          ])
        ]))
      : _createCommentVNode("", true)
  ], 512)), [
    [_vShow, _ctx.showRow]
  ])
}